import Recommendations from './recommendations';

export default {
  namespaced: true,

  modules: {
    recommendations: Recommendations,
  },

  actions: {
    save({getters}) {
      const local = {
        recommendations: getters['recommendations/get'],
      };

      window.localStorage.setItem('sizingApp', JSON.stringify(local));
    },

    load({commit}) {
      try {
        const local = JSON.parse(window.localStorage.getItem('sizingApp'));
        if (!local) return;

        commit('recommendations/set', local.recommendations || []);
      } catch (e) {}
    },
  },
};
